module.exports = __webpack_public_path__ + "static/img/about_us.706d7b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/about_us.png
// module id = mSCv
// module chunks = 0